import { Component, Input, EventEmitter, OnInit } from '@angular/core';
import { ServerSettingsViewModel, SettingsService, DomainViewModel, GeocoderViewModel, MapLayerViewModel } from '../../../../services/settings.service';
import { TranslateService } from "@ngx-translate/core";
import { Observable } from 'rxjs';

@Component({
    selector: 'app-server-settings',
    templateUrl: './server-settings.component.html',
    styleUrls: ['./server-settings.component.css'],
    standalone: false
})
export class ServerSettingsComponent implements OnInit {

  @Input()
  public apply: Observable<void>;

  public model = new ServerSettingsViewModel();

  constructor(protected settingsService: SettingsService, protected translate: TranslateService) {
  }

  ngOnInit() {
    this.Refresh();
    this.apply.subscribe(() => { this.Apply(); });
  }
  protected Refresh() {
    this.settingsService.getServerSettings().subscribe(res => { this.model = res; });
  }

  public addItem(array: Array<any>)
  {
    if (array === this.model.domains)
      this.model.domains.push(new DomainViewModel());
    if (array === this.model.geocoders)
      this.model.geocoders.push(new GeocoderViewModel());
    if (array === this.model.maplayers)
      this.model.maplayers.push(new MapLayerViewModel());
  }
  public deleteItem(item: any, array: Array<any>) {

    let message = this.translate.instant("Delete");
    if (!confirm(message + " " + item.Name + "?"))
      return;

    for (let i = 0; i < array.length; i++)
      if (item === array[i])
        array.splice(i, 1);
  }
  public pullUp(item: any, array: Array<any>) {
    for (let i = 1; i < array.length; i++)
      if (array[i] === item)
      {
        const prev = array[i - 1];
        array[i - 1] = item;
        array[i] = prev;
        break;
      }
  }

  public pullDown(item: any, array: Array<any>) {
    for (let i = 0; i < array.length - 1; i++)
      if (array[i] === item) {
        const next = array[i + 1];
        array[i + 1] = item;
        array[i] = next;
        break;
      }
  }
  private Apply() {
    this.settingsService.setServerSettings(this.model).subscribe(() => {
      this.Refresh();
    });
  }
}
